<template>
    <div class="layer">
        <h2>검색 결과 : 총 {{totalCount}}건</h2>
        <el-table :data="list"
                  border
                  stripe
                  style="width: 100%">
            <el-table-column prop="name"
                             label="이름"
                             fixed
                             width="200">
            </el-table-column>
            <el-table-column label="섬네일"
                             fixed
                             width="120">
                <template slot-scope="scope">
                    <img :src="getImageFullPath(scope.row.imagePath)" :alt="scope.row.name" v-if="scope.row.imagePath"
                         width="80px">
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column prop="userId"
                             label="유저ID"
                             width="160">
            </el-table-column>
            <el-table-column prop="phone"
                             label="전화번호"
                             width="160">
            </el-table-column>
            <el-table-column prop="description"
                             label="소개"
                             width="280">
            </el-table-column>
            <el-table-column label="마지막 로그인"
                             width="200">
                <template slot-scope="scope">{{scope.row.lastLogin | dateTime}}</template>
            </el-table-column>
            <el-table-column label="가입일"
                             width="200">
                <template slot-scope="scope">{{scope.row.createdAt | dateTime}}</template>
            </el-table-column>
            <el-table-column label="마지막 수정일"
                             width="200">
                <template slot-scope="scope">{{scope.row.updatedAt | dateTime}}</template>
            </el-table-column>
            <el-table-column label="권한"
                             width="200">
                <template slot-scope="scope">
                    <el-tag type="warning"
                            effect="dark"
                            v-for="item in scope.row.permissions" :key="item.permission">{{item.permission}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="상태"
                             fixed="right"
                             width="80">
                <template slot-scope="scope">
                    <el-tag type="success" effect="dark" v-if="scope.row.isValid">정상</el-tag>
                    <el-tag type="danger" effect="dark" v-else>정지</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="관리"
                             fixed="right"
                             width="160">
                <template slot-scope="scope">
                    <el-button type="warning" size="small" @click.prevent="editUser(scope.row)">수정</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination :page-size="pageSize"
                       :current-page="page"
                       :pager-count="11"
                       :total="totalCount"
                       layout="prev, pager, next"
                       @current-change="getUsers">
        </el-pagination>
    </div>
</template>

<script>
    import {USER_GET_LIST, USER_RESET_LIST, USER_SET_EDIT_USER} from '@/store/modules/user';
    import imageController from '@/components/mixins/imageController';
    import errorController from '@/components/mixins/errorController';
    import {ROUTE_USERS_EDIT} from '@/router/routeNames';

    export default {
        name: 'UserList',
        mixins: [imageController, errorController],
        watch: {
            filters: {
                deep: true,
                handler() {
                    this.getUsers();
                },
            },
        },
        computed: {
            list() {
                return this.$store.state.user.list;
            },
            page() {
                return this.$store.state.user.page;
            },
            pageSize() {
                return this.$store.state.user.pageSize;
            },
            totalCount() {
                return this.$store.state.user.totalCount;
            },
            filters() {
                return this.$store.state.user.filters;
            },
        },
        methods: {
            async getUsers(page = 1) {
                try {
                    await this.$store.dispatch(USER_GET_LIST, page);
                } catch (err) {
                    await this.$store.dispatch(USER_RESET_LIST);
                    this.displayApiError(err);
                }
            },
            async editUser(user) {
                await this.$store.dispatch(USER_SET_EDIT_USER, user);
                this.$router.push({name: ROUTE_USERS_EDIT});
            },
        },
        created() {
            this.getUsers();
        },
    };
</script>

<style lang="scss" scoped>
    h2 {
        font-size: 16px;
        margin-bottom: 5px;
        color: #545c64;
    }
</style>